import 'date-fns';
import React, { useEffect, useState, useCallback } from 'react';
import { Grid, makeStyles } from "@material-ui/core"
import DateFnsUtils from '@date-io/date-fns';
import GetAppIcon from '@material-ui/icons/GetApp';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { Button, CircularProgress } from '@material-ui/core';
import { ImcGenericStyle } from './ImcGenericStyle';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

export default function FiltroDetalleUser({ reloadTable, filter, setFilter, filterCedula, dowload, setFilterCedula, handlerFilter, isLoading, isDate, titlePanel = 'Datos De Isla' }) {
  const location = useLocation();

  const [dataStart, setDataStart] = useState();
  const [dataEnd, setDataEnd] = useState();

  const classes = ImcGenericStyle();

  const handleDateChange = (date) => {
    setDataStart(date);
    localStorage.setItem('DATE_INIT', date.toISOString()); // Guardar dataStart en localStorage
  };

  const handleDateEnd = (date) => {
    setDataEnd(date);
    localStorage.setItem('DATE_END', date.toISOString()); // Guardar dataStart en localStorage
  };

  const handerSendFilter = () => {
    // Ajustar la fecha final restando un día
    const adjustedEndDate = new Date(dataEnd);
    adjustedEndDate.setDate(adjustedEndDate.getDate() - 1);

    handlerFilter(dataStart, adjustedEndDate);
  };

  const adjustTimeZone = (date) => {
    const timeZoneOffset = date.getTimezoneOffset() * 60000; // Offset en milisegundos
    return new Date(date.getTime() - timeZoneOffset);
  };

  const initDates = useCallback(() => {
    let init, end;

    if (!isDate) {
      init = new Date();
      end = new Date(init.getTime() - 2629750000);
    } else {
      init = adjustTimeZone(new Date(location.state.fechaIinicial));
      end = adjustTimeZone(new Date(location.state.fechaFinal));
    }

    setDataStart(init);
    setDataEnd(end);

  }, [isDate, location.state]);


  useEffect(() => {
    initDates();
  }, [initDates]);

  const customDatePickerMonthNavIcons = makeStyles((theme) => ({
    root: {
      '& .MuiSvgIcon-root': {
        fill: theme.palette.primary.main, // Cambia el color de los iconos de navegación de meses a primary
      },
    },
  }));
  return (
    <>
      <Typography align="center" variant="h4" style={{ fontSize: "35pt", fontWeight: 'bold' }} color='primary' >Filtros </Typography>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4} md={3}>
            <KeyboardDatePicker
              type='textdate'
              disableToolbar
              variant="inline"
              format="yyyy-MM-dd"
              margin="normal"
              id="date-picker-inline"
              label="Fecha inicial"
              value={dataStart}
              style={{ textTransform: "none", width: "100%" }}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              className={customDatePickerMonthNavIcons().root}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <KeyboardDatePicker
              type='textdate'
              disableToolbar
              variant="inline"
              format="yyyy-MM-dd"
              minDate={dataStart}
              margin="normal"
              id="date-picker-inline"
              label="Fecha Final"
              value={dataEnd}
              style={{ textTransform: "none", width: "100%" }}
              onChange={handleDateEnd}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              className={customDatePickerMonthNavIcons().root}

            />
          </Grid>
          <Divider style={{ marginLeft: '1%', background: 'black' }} orientation="vertical" flexItem />
          <Grid item xs={12} sm={6} md={5} >
          </Grid>
          <Grid item xs={12} sm={6} md={6} style={{ marginTop: '1%' }}>
            <div className={classes.wrapper}>
              <Button
                disabled={isLoading}
                type="submit"
                variant="contained"
                color="primary"
                onClick={(filter) => {
                  handerSendFilter(filter)
                }}
                style={{ textTransform: "none", width: "100%" }}
              >
                Filtro
              </Button>
              {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={6} style={{ marginTop: '1%' }}>
            <div className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<GetAppIcon />}
                style={{ backgroundColor: "#2bb673", width: '100%' }}
                onClick={() => {
                  const formattedStartDate = new Date(dataStart).toISOString().split('T')[0];
                  const formattedEndDate = new Date(dataEnd).toISOString().split('T')[0];
                  dowload(formattedStartDate, formattedEndDate);
                }}
              >
                Descargar
              </Button>
              {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </>
  );
}
